import * as tslib_1 from "tslib";
import { GeometryModel } from './geometry-model';
var MapboxGeometryModel = (function (_super) {
    tslib_1.__extends(MapboxGeometryModel, _super);
    function MapboxGeometryModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return MapboxGeometryModel;
}(GeometryModel));
export { MapboxGeometryModel };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibWFwYm94LWdlb21ldHJ5LW1vZGVsLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibWFwYm94LWdlb21ldHJ5LW1vZGVsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLEVBQUMsYUFBYSxFQUFDLE1BQU0sa0JBQWtCLENBQUM7QUFFL0M7SUFBeUMsK0NBQWE7SUFBdEQ7O0lBRUEsQ0FBQztJQUFELDBCQUFDO0FBQUQsQ0FBQyxBQUZELENBQXlDLGFBQWEsR0FFckQifQ==